var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"siderbar-warpper"},[_c('el-menu',{staticClass:"el-menu-demo",attrs:{"router":true,"default-active":`${_vm.sysPath}/` + `${_vm.URL}/` + _vm.activeIndex,"mode":"vertical"}},_vm._l((_vm.routes),function(router){return _c('siderbar-item',{key:router.path,attrs:{"item":router,"base-path":router.path}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }